import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { UserStatus } from '../../models/dashboard';
import { UiNotificationService } from '../../services/ui-notification.service';
import { DateOnlyPipe, DurationPipe, StatusDatePipe } from '../../utilities/date-pipes';
import { ThresholdIndicatorComponent } from '../threshold-indicator/threshold-indicator.component';
import { TrendIndicatorComponent } from '../trend-indicator/trend-indicator.component';
import { Reset } from '../../utilities/reset';

@Component({
  selector: '[app-patient-row]',
  imports: [
    FormsModule,
    CommonModule,
    DateOnlyPipe,
    StatusDatePipe,
    ButtonModule,
    TranslatePipe,
    DurationPipe,
    ProgressBarModule,
    ThresholdIndicatorComponent,
    TrendIndicatorComponent
  ],
  templateUrl: './patient-row.component.html',
  standalone: true,
  styleUrls: ['./patient-row.component.css'],
})
export class PatientRowComponent {
  @Input() user: UserStatus = Reset.userStatus();
  @Input() messageService!: UiNotificationService;
  @Input() routerService!: Router;

  @Input() showSteps: boolean = false;
  @Input() showStatus: boolean = false;

  movPercentage: number = 0.0;

  ngOnChanges() {
    if (this.user === undefined || this.user === null) {
      this.movPercentage = 0.0;
    } else {
      this.movPercentage = this.user.metrics.minutesRst / this.user.metrics.minutesTot;
    }
  }

  public getPercentage(value: number): number {
    return value * 100.0;
  }

  onShowUser(user: UserStatus) {
    this.routerService.navigate(['/summary'], { 
      state: { id: user.id } 
    });
  }
}
